import { tryGetHostApi } from "./externalApi";
export async function acceptPrivacyNotice() {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 1, 1);
    if (dashboardHostApi) {
        await dashboardHostApi.acceptPrivacyNotice();
    }
}
export async function requestRefresh() {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 1, 1);
    if (dashboardHostApi) {
        dashboardHostApi.requestRefresh();
    }
}
export async function setLaunchAttributionContext(context) {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 1, 1);
    if (dashboardHostApi) {
        dashboardHostApi.setLaunchAttributionContext(context);
    }
}
export async function clearLaunchAttributionContext() {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 1, 1);
    if (dashboardHostApi) {
        dashboardHostApi.setLaunchAttributionContext("");
    }
}
export async function notifyContentDisplayReady() {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 1, 1);
    if (dashboardHostApi) {
        await dashboardHostApi.notifyContentDisplayReady();
    }
}
export async function setDashboardLoading(isLoading = false) {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 3, 3);
    if (dashboardHostApi) {
        await dashboardHostApi.setDashboardLoading(isLoading);
    }
}
export async function getUserDisplayLocale() {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 1, 1);
    if (dashboardHostApi) {
        return await dashboardHostApi.userDisplayLocale;
    }
    else {
        return "";
    }
}
export async function getUserTimeFormatEx() {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 1, 1);
    if (dashboardHostApi) {
        return await dashboardHostApi.userTimeFormatEx;
    }
    else {
        return "";
    }
}
export async function requestClearCache() {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 4, 4);
    if (dashboardHostApi) {
        dashboardHostApi.requestClearCache();
    }
}
export async function setIsMeteredConnectionUsageAllowedForMigration(enabled) {
    const dashboardHostApi = await tryGetHostApi("DashboardHost", 4, 4);
    if (dashboardHostApi) {
        dashboardHostApi.setIsMeteredConnectionUsageAllowedForMigration(enabled);
    }
}
